import { Type } from "class-transformer";
import { Role } from "./Role";
import { UserDevice } from "./User";

export class PersonAuth {
    email!: string;
    mfa_active!: boolean;
    /** Included only when session details are explicitly requested. */
    devices?: UserDevice[];
}

export class Person {

    constructor() {
        this.roles = [];
        this.customers = [];
        this.accounts = [];
        this.suppliers = [];
    }

    id!: string;
    name!: string;
    last_name!: string;
    title!: string;
    roles!: Role[];
    email!: string;
    email_verified: string | null = null;
    birth_date: string = "";
    phone!: string;
    locale: string = "en";
    customers!: string[];
    accounts!: string[];
    suppliers!: string[];

    @Type(() => PersonAuth)
    auth!: PersonAuth | null;

    public getDefaultCustomerId(): string {
        return this.accounts[0];
    }
}
